import api from "./api";

export const getPodcasts = async (params = {}) => {
  try {
    const res = await api.get("/podcasts/", { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching podcasts:", error);
    throw error;
  }
};

export const getPodcastById = async (id) => {
  try {
    const res = await api.get(`/podcasts/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching podcast:", error);
    throw error;
  }
};

export const createPodcast = async (data) => {
  try {
    // API formatına uygun olarak veriyi düzenle
    const formattedData = {
      title: data.title,
      description: data.description,
      summary: data.summary,
      status: data.status || 'draft',
      language: data.language || 'tr'
    };
    
    console.log("Sending podcast data:", formattedData);
    const res = await api.post("/podcasts/", formattedData);
    return res.data;
  } catch (error) {
    console.error("Error creating podcast:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const updatePodcast = async (id, data) => {
  try {
    // API formatına uygun olarak veriyi düzenle
    const formattedData = {
      title: data.title,
      description: data.description,
      summary: data.summary,
      status: data.status || 'draft',
      language: data.language || 'tr'
    };
    
    console.log("Updating podcast data:", formattedData);
    const res = await api.put(`/podcasts/${id}`, formattedData);
    return res.data;
  } catch (error) {
    console.error("Error updating podcast:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const deletePodcast = async (id) => {
  try {
    const res = await api.delete(`/podcasts/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting podcast:", error);
    throw error;
  }
};

export const uploadPodcastThumbnail = async (id, file) => {
  try {
    console.log("=== UPLOADING PODCAST THUMBNAIL ===");
    console.log("Podcast ID:", id);
    console.log("File:", file.name, file.size, "bytes", file.type);
    
    const formData = new FormData();
    formData.append("image", file);
    
    console.log("Making request to:", `/podcasts/${id}/thumbnail`);
    const res = await api.post(`/podcasts/${id}/thumbnail`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("Upload successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPLOADING PODCAST THUMBNAIL ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};

export const uploadPodcastAudio = async (id, file, language = 'tr') => {
  try {
    console.log("=== UPLOADING PODCAST AUDIO ===");
    console.log("Podcast ID:", id);
    console.log("Language:", language);
    console.log("File:", file.name, file.size, "bytes", file.type);
    
    const formData = new FormData();
    formData.append("audio", file);
    formData.append("language", language);
    
    console.log("Making request to:", `/podcasts/${id}/audio`);
    const res = await api.post(`/podcasts/${id}/audio`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("Upload successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPLOADING PODCAST AUDIO ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};

export const removePodcastAudio = async (id) => {
  try {
    console.log("=== REMOVING PODCAST AUDIO ===");
    console.log("Podcast ID:", id);
    
    // Podcast'i güncelle ve audioUrl'i null yap
    const res = await api.put(`/podcasts/${id}`, {
      audioUrl: null
    });
    console.log("Audio removal successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR REMOVING PODCAST AUDIO ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};

export const removePodcastThumbnail = async (id) => {
  try {
    console.log("=== REMOVING PODCAST THUMBNAIL ===");
    console.log("Podcast ID:", id);
    
    // Podcast'i güncelle ve thumbnailUrl'i null yap
    const res = await api.put(`/podcasts/${id}`, {
      thumbnailUrl: null
    });
    console.log("Thumbnail removal successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR REMOVING PODCAST THUMBNAIL ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
    }
    throw error;
  }
};

